<div id="plantation-select-panel">
  <p class="active-manu-label">{{ 'doktar_app.menu.services' | translate }}</p>

  <div class="filter-container">
    <div class="filter-item">
      <dk-search-icon />

      <input
        type="text"
        [placeholder]="'doktar_app.common.search_placeholder' | translate"
        [(ngModel)]="searchText"
        (keyup)="onSearch()"
        [disabled]="plantationService.loading$ | async" />
    </div>
    <div class="filter-item filter-tool" (click)="onOpenFilterModal()">
      <i class="ph-fill ph-sliders-horizontal"></i>
    </div>
    <div class="filter-item filter-tool">
      <i class="ph ph-sort-ascending" (click)="sortPopover.toggle($event)"></i>
      <p-popover #sortPopover>
        <div id="land-plantation-popover" class="sort-popover">
          @for (item of sortOptions; track item.value; let index = $index) {
            <div class="sort-item-row" (click)="onSelectSortItem(index)">
              <span>{{ item.label | translate }}</span>
              @if (!item.selected) {
                <i class="ph ph-circle icon"></i>
              } @else {
                <i class="ph-fill ph-radio-button icon"></i>
              }
            </div>
          }
        </div>
      </p-popover>
    </div>
  </div>

  @if ((plantationService.loading$ | async) !== true) {
    <div class="land-container">
      @if (filteredLands?.length > 0) {
        @for (land of filteredLands; track land) {
          <div class="land">
            <p class="land-name">{{ land.name }}</p>
            @for (plantation of land.plantations; track plantation; let plantationIndex = $index) {
              <div class="plantation-row" [class.mt-3]="plantationIndex !== 0">
                <div class="plantation-placeholder">
                  <div
                    class="card-image"
                    [dkSafeImage]="plantation?.image"
                    fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
                    backgroundStyle="lightgray 50% / cover no-repeat"
                    [showSpinner]="true"></div>
                  </div>
                <div class="plantation-detail" (click)="onSelectPlantation(land, plantation)">
                  <div class="">
                    <div class="d-flex align-items-center gap-2">
                      <span
                        class="plantation-crop-color"
                        [style.backgroundColor]="plantation.cropColor ?? '#fff'"></span>
                      <span class="plantation-name">{{ plantation.name }}</span>
                    </div>
                    <div class="plantation-total-area">
                      <span [class.d-none]="!plantation.crop?.value">{{ plantation.crop?.value }},</span>
                      <span>{{ plantation.totalAreaDisplay }}</span>
                      <span class="px-1">{{ ' ' + ('doktar_app.land_plantation.planted' | translate) }}</span>
                    </div>
                  </div>

                  <span>
                    @if (selectedPlantation?.id == plantation.id) {
                      <i class="ph-fill ph-radio-button icon"></i>
                    }
                  </span>
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <p class="no-land-plantation">{{ 'doktar_app.land_plantation.no_land_plantation_found' | translate }}</p>
      }
    </div>

    <div class="add-new-plantation-contaner">
      <p-button
        id="add-new-plantation-btn"
        [label]="'doktar_app.land_plantations.add_new_button_title' | translate"
        severity="secondary"
        [routerLink]="'/lands'" />
    </div>
  } @else {
    <p-skeleton height="1.5rem" width="50%" styleClass="mb-2 mt-2" />
    <div class="row">
      <div class="col-auto"><p-skeleton size="4rem" styleClass="mr-2" /></div>
      <div class="col"><p-skeleton height="4rem" width="100%" styleClass="mb-2" /></div>
    </div>

    <p-skeleton height="1.5rem" width="50%" styleClass="mb-2 mt-4" />
    <div class="row">
      <div class="col-auto"><p-skeleton size="4rem" styleClass="mr-2" /></div>
      <div class="col"><p-skeleton height="4rem" width="100%" styleClass="mb-2" /></div>
    </div>
    <div class="row">
      <div class="col-auto"><p-skeleton size="4rem" styleClass="mr-2" /></div>
      <div class="col"><p-skeleton height="4rem" width="100%" styleClass="mb-2" /></div>
    </div>

    <p-skeleton height="1.5rem" width="50%" styleClass="mb-2 mt-4" />
    <div class="row">
      <div class="col-auto"><p-skeleton size="4rem" styleClass="mr-2" /></div>
      <div class="col"><p-skeleton width="100%" height="4rem" styleClass="mb-2" /></div>
    </div>

    <p-skeleton height="1.5rem" width="50%" styleClass="mb-2 mt-4" />
    <div class="row">
      <div class="col-auto"><p-skeleton size="4rem" styleClass="mr-2" /></div>
      <div class="col"><p-skeleton height="4rem" width="100%" styleClass="mb-2" /></div>
    </div>
    <div class="row">
      <div class="col-auto"><p-skeleton size="4rem" styleClass="mr-2" /></div>
      <div class="col"><p-skeleton height="4rem" width="100%" styleClass="mb-2" /></div>
    </div>
  }
</div>
